import '../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/globals';

import 'object-fit-videos';
import 'vanilla-lazyload';
import 'lazyembed2';
import 'jquery';
import '@popperjs/core';
import 'isotope-layout';

/**
 * Bootstrap
 */
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
//import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
//import 'bootstrap/js/src/scrollspy';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/tooltip';
import 'bootstrap/js/src/popover';

// /**
//  * Bootstrap Multiselect
//  */
// import 'bootstrap-select';

/**
 * Slick
 */
import 'slick-carousel';

/**
 * Light Gallery
 */
import 'lightgallery';
//import 'lg-autoplay';
//import 'lg-fullscreen';
//import 'lg-hash';
//import 'lg-pager';
//import 'lg-share';
//import 'lg-thumbnail';
//import 'lg-video';
//import 'lg-zoom';

/**
 * TwentyTwenty
 */
import 'zurb-twentytwenty/js/jquery.event.move';
import 'zurb-twentytwenty/js/jquery.twentytwenty';

/**
 * Splide-Slider
 */
import '../../../../../Packages/Plugins/Avency.Neos.BaseSplideSlider/Resources/Private/Assets/JavaScripts/SplideSlider';

/**
 * Project
 */
import '../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/functions';
import '../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/Viewport';
import '../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/sizeChange';
import '../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/PageLoadedQueue';
// import '../../../../Avency.Avency.Base/Resources/Private/Assets/JavaScript/Project/forms'; // ToDo: Replace?
import '../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/objectFitVideos';
// import '../../../../Avency.Avency.Base/Resources/Private/Assets/JavaScript/Project/counter'; // @ToDo: convert to vanilla JS
// import '../../../../Avency.Avency.Base/Resources/Private/Assets/JavaScript/Project/circleCounter'; // @ToDo: convert to vanilla JS
// import '../../../../Avency.Avency.Base/Resources/Private/Assets/JavaScript/Project/downloadFilters'; // @ToDo: convert to vanilla JS
// import '../../../../Avency.Avency.Base/Resources/Private/Assets/JavaScript/Project/lightGallery'; // @ToDo: convert to vanilla JS
import '../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/Lazyload';
import '../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/lazyEmbed';
import '../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/slick'; // @ToDo: convert to vanilla JS / Replace?
import '../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/navbar';

import '../../../../Avency.Avency.Shared/Resources/Private/Fusion/Component/Atom/RetypingEffect/RetypingEffect';
// import '../../../../Avency.Avency.Shared/Resources/Private/Fusion/Component/Atom/Icon/Icon';
import '../../../../Avency.Avency.Services/Resources/Private/Fusion/Component/Molecule/Slider/Slider';

import '../../../../Avency.Avency.Shared/Resources/Private/Fusion/Component/Molecule/Menu/LandingpageMenu';

import '../../../../Avency.Avency.News/Resources/Private/Fusion/Component/Molecule/List/List';

import '../../../../Avency.Avency.Customers/Resources/Private/Fusion/Component/Molecule/CustomerSlider/CustomerSlider' // @ToDo: convert to vanilla JS / Replace?

import '../../../../Avency.Avency.References/Resources/Private/Fusion/Component/Molecule/ReferenceList/References';
import '../../../../Avency.Avency.References/Resources/Private/Fusion/Component/Molecule/CustomReferenceList/CustomReferenceList';
import '../../../../Avency.Avency.References/Resources/Private/Fusion/Component/Atom/BeforeAfterImage/BeforeAfterImage';

// import '../../../../Avency.Avency.News/Resources/Private/Fusion/Component/Molecule/NewsCardCollection/NewsCardCollection';

import '../../../../Avency.Avency.Shared/Resources/Private/Fusion/Component/Molecule/AvencySplitSlider/AvencySplitSlider';
// import '../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/particles'; // ToDo: Korrigiere Overflow
import '../../../../Avency.Avency.Shared/Resources/Private/Assets/JavaScript/Project/dropdown';

// Glossary
import "../../../../../Packages/Plugins/Avency.Neos.Glossary/Resources/Private/Fusion/Component/Molecule/Glossary/Glossary";
